import React from 'react';

import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

export default function NoNotificationsView() {
  const mouseDown = (e) => {
    e.stopPropagation();
  };
  return (
    <Container onMouseDown={mouseDown}>
      <StyledTypography align="center" color="textSecondary">
        Hey, no notifications yet. I will notify you if something needs your attention!
      </StyledTypography>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${(props) => props.theme.spacing(1)}rem ${(props) => props.theme.spacing(4)}rem;
  margin-bottom: 0.5rem;
  font-style: italic;
  height: 20vh;
`;
